/* eslint-disable max-len */
import React from 'react';

const Cross = ({ width = '14', height = '14' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.39164 6.99994L3.37309 3.90816C3.2299 3.7615 3.22979 3.52359 3.37285 3.37678C3.51591 3.22997 3.74796 3.22986 3.89116 3.37653L6.97398 6.53414C6.99061 6.53298 7.00731 6.53298 7.02394 6.53414L10.1068 3.37653C10.25 3.22986 10.482 3.22997 10.6251 3.37678C10.7681 3.52359 10.768 3.7615 10.6248 3.90816L7.60628 6.99994L10.6248 10.0917C10.768 10.2384 10.7681 10.4763 10.6251 10.6231C10.482 10.7699 10.25 10.77 10.1068 10.6233L7.02394 7.46573C7.00731 7.46689 6.99061 7.46689 6.97398 7.46573L3.89116 10.6233C3.74796 10.77 3.51591 10.7699 3.37285 10.6231C3.22979 10.4763 3.2299 10.2384 3.37309 10.0917L6.39164 6.99994Z"
      fill="black"
    />
  </svg>
);

export default Cross;
